var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBa3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 345.898,
    height: 168.031,
    viewBox: "0 0 345.898 168.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5336.091 -1196.581)",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6e7e9d",
    d: "M5336.091 1364.112h226.208m-163.409-27.428v27.428m33.537-68.033v68.033m33.537-92.637v92.637m33.537-83.242v83.242m33.538-111.846v111.846"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5463.042 1260.775)",
    fill: "none",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5465.964 1255.918v-51.559h81.236m89.779 79.367v18.15m-38.666 2.39h14.95m5.844 0h14.95m5.844 0h14.95m5.844 0h14.95m-77.332 18.975h14.95m5.844 0h14.95m5.844 0h14.95m5.844 0h14.95m-77.332 18.974h14.95m5.844 0h14.95m5.844 0h14.95m5.844 0h14.95m-77.332 18.975h14.95m5.844 0h14.95m5.844 0h14.95m5.844 0h14.95m-38.666-54.002v13.131m-20.794 5.843v13.131m41.588-13.131v13.131m-62.382 5.844v13.131m83.177-13.131v13.131m-122.828-146.131v-15.556m-8.536 15.556v-15.556",
    fill: "none",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    d: "M5365.352 1325.288v38.823"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5357.574 1309.732)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5391.111 1321.127)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5424.649 1280.523)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5458.186 1255.918)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5491.723 1265.314)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5525.261 1236.709)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    d: "M5391.469 1326.571l-18.774-6.513m54.88-25.683l-23.812 28.472m55.827-54.7l-20.882 15.579m53.268-12.569l-18.685-4.868m53.831-16.758l-21.838 18.616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5555.74 1204.359h81.24v24.732",
    fill: "none",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    d: "M5592.469 1229.091h89.02v54.635h-89.02zm39.469 10.765h-20.195m20.195 6.622h-20.195m20.195 6.621h-20.195m20.195 6.621h-20.195m20.195 6.621h-20.195m20.195 6.621h-20.195m-4.073-33.104h-6.065m6.065 6.621h-6.065m6.065 6.621h-6.065m6.065 6.621h-6.065m6.065 6.621h-6.065m6.065 6.622h-6.065"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.553,
    cy: 16.553,
    r: 16.553,
    transform: "translate(5641.742 1239.856)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.878,
    cy: 6.878,
    r: 6.878,
    transform: "translate(5651.417 1249.531)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    d: "M5665.172 1256.409h9.675m-16.553-6.878v-9.675"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5592.469 1301.344)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5613.263 1301.344)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5634.058 1301.344)",
    fill: "#0c9",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5654.852 1301.344)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5675.646 1301.344)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5592.469 1320.319)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5613.263 1320.319)",
    fill: "#0c9",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5634.058 1320.319)",
    fill: "#0c9",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5654.852 1320.319)",
    fill: "#0c9",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5675.646 1320.319)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5592.469 1339.293)",
    fill: "#0c9",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5613.263 1339.293)",
    fill: "#0c9",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5634.058 1339.293)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5654.852 1339.293)",
    fill: "#0c9",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5675.646 1339.293)",
    fill: "#0c9",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5592.469 1358.268)",
    fill: "#0c9",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5613.263 1358.268)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5634.058 1358.268)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5654.852 1358.268)",
    fill: "none",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.922,
    cy: 2.922,
    r: 2.922,
    transform: "translate(5675.646 1358.268)",
    fill: "#0c9",
    stroke: "#0c9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa3);
export default __webpack_public_path__ + "static/media/ba3.1bedc03e4d5ad3fdc4412d50d607f39b.svg";
export { ForwardRef as ReactComponent };